(function() {
    return {
        start() {
            this.setupDiplomaFileField();
            this.setupCertificatePopper();
        },
        setupDiplomaFileField() {
            const hasDiplomaFields = document.querySelectorAll('[name="has_diploma"]');
            const diplomaFileGroup = document.querySelector('#field-group-diploma-file-field');

            hasDiplomaFields.forEach(input => {
                input.addEventListener('change', ({ target: { value } }) => {
                    const form = this.getForm();

                    if (value === 'yes') {
                        diplomaFileGroup.classList.add('show');

                        if (form) {
                            const fileInput = diplomaFileGroup.querySelector('input');
                            const fileLabel = diplomaFileGroup.querySelector('label');

                            fileInput.setAttribute('required', '');

                            if (!fileLabel.querySelector('span')) {
                                fileLabel.classList.add('is-required');
                                fileLabel.innerHTML += '<span>*</span>';
                            }

                            this.getForm()?.refreshFields();
                        }

                        return;
                    }

                    diplomaFileGroup.classList.remove('show');

                    if (form) {
                        const fileInput = diplomaFileGroup.querySelector('input');

                        fileInput.removeAttribute('required');
                        fileInput.parentNode.setAttribute('data-caption', fileInput.dataset.caption);
                        fileInput.value = '';

                        this.getForm()?.refreshFields();
                    }
                });
            })
        },
        setupCertificatePopper() {
            if (!window.tippy) {
                return;
            }

            const template = document.querySelector('#certificate-field-popper-template');
            const group    = document.querySelector('#field-group-certificate-field');

            group.appendChild(template.content);
        },
        getForm() {
            return document.forms?.[0]?.__view || null;
        },
    };
})().start();